var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.exists(_vm.filename))?_c('b-img',{attrs:{"src":require(`~img/${_vm.filename}`)}}):(_setup.exists(_vm.fallback))?_c(_setup.ImageRetina,{attrs:{"filename":_vm.fallback}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }